export default __webpack_public_path__ + "static/media/Gauntlets of the Black Dragon.8589a0fd.jpg";